import { createReducer } from 'typesafe-actions';
import produce from 'immer';

import * as Actions from '../actions/analysisHistoryAction';
import {
  initResponseAnalysisHistoryData,
  AnalysisHistoryData,
  AnalysisHistoryState
} from '../models/analysisHitoryModel';
import { controlGpSaga } from '../../../control/gp';

export const analysisHistoryReducer = createReducer<
  AnalysisHistoryState,
  Actions.AnalysisHistoryAction
>(initResponseAnalysisHistoryData)
  .handleAction(Actions.dispatchSearch, (state, action) =>
    produce(state, draft => {
      const { searchParams } = action.payload;
      draft.searchParams = searchParams;
    })
  )
  .handleAction(Actions.list.request, (state, action) =>
    produce(state, draft => {
      const { searchParams, page } = action.payload;
      draft.searchParams = searchParams;
      draft.page = page;
    })
  )
  .handleAction(Actions.list.success, (state, action) =>
    produce(state, draft => {
      const { data, count, total } = action.payload;

      draft.data = data;
      draft.count = count;
      draft.total = total;
    })
  )
  .handleAction(Actions.detail.success, (state, action) =>
    produce(state, draft => {
      const { detail } = action.payload;
      draft.detail = detail;
    })
  )
  .handleAction(Actions.log.success, (state, action) =>
    produce(state, draft => {
      const { log } = action.payload;
      draft.log = log;
    })
  )
  .handleAction(Actions.LIST_INITAL, (state, action) =>
    produce(state, draft => {
      draft.data = initResponseAnalysisHistoryData.data;
      draft.count = initResponseAnalysisHistoryData.count;
      draft.total = initResponseAnalysisHistoryData.total;
    })
  );
